import {
  MEETING_INTELLIGENCE_FEATURES
} from 'features/billing/modals/plan_selection_modal/config/addons'
import {
  STANDARD,
  STANDARD_NOTETAKER,
  STANDARD_SCHEDULING,
  TEAMS,
  TEAMS_NOTETAKER,
  TEAMS_SCHEDULING
} from 'features/billing/modals/plan_selection_modal/config/tiers'

const NOTETAKER_UPGRADE_TARGETS = {
  [STANDARD_SCHEDULING]: STANDARD_NOTETAKER,
  [TEAMS_SCHEDULING]: TEAMS_NOTETAKER
}

const TEAMS_UPGRADE_TARGETS = {
  [STANDARD_SCHEDULING]: TEAMS_SCHEDULING,
  [STANDARD_NOTETAKER]: TEAMS_NOTETAKER
}

const normalizeTier = (tier) => (typeof tier === 'string' ? tier.toLowerCase() : tier)
const isMeetingIntelligenceFeature = (featureKey) => MEETING_INTELLIGENCE_FEATURES.includes(featureKey)
const tierIncludesNotetaker = (tier) => [STANDARD_NOTETAKER, TEAMS_NOTETAKER].includes(tier)

const resolveNotetakerExperimentTargetTier = ({
  currentTier,
  featureKey,
  requestedTier
}) => {
  const normalizedCurrentTier = normalizeTier(currentTier)
  const normalizedRequestedTier = normalizeTier(requestedTier)
  const meetingIntelligenceFeature = isMeetingIntelligenceFeature(featureKey)

  if (meetingIntelligenceFeature && normalizedRequestedTier === STANDARD) {
    if ([TEAMS_SCHEDULING, TEAMS_NOTETAKER].includes(normalizedCurrentTier)) {
      return TEAMS_NOTETAKER
    }

    return STANDARD_NOTETAKER
  }

  if (normalizedRequestedTier === STANDARD) {
    return STANDARD_SCHEDULING
  }

  if (normalizedRequestedTier === TEAMS) {
    if (meetingIntelligenceFeature || tierIncludesNotetaker(normalizedCurrentTier)) {
      return TEAMS_NOTETAKER
    }

    return TEAMS_SCHEDULING
  }

  return normalizedRequestedTier
}

export const resolveUpgradeTargetTier = ({
  currentTier,
  featureKey,
  requestedTier,
  isNotetakerPlanSelectionVariant = false
}) => {
  const normalizedCurrentTier = normalizeTier(currentTier)
  const normalizedRequestedTier = normalizeTier(requestedTier)

  if (!normalizedRequestedTier) return requestedTier

  if (isNotetakerPlanSelectionVariant) {
    return resolveNotetakerExperimentTargetTier({
      currentTier: normalizedCurrentTier,
      featureKey,
      requestedTier: normalizedRequestedTier
    })
  }

  if (
    isMeetingIntelligenceFeature(featureKey)
    && normalizedRequestedTier === STANDARD
  ) {
    return NOTETAKER_UPGRADE_TARGETS[normalizedCurrentTier] || normalizedRequestedTier
  }

  if (normalizedRequestedTier === TEAMS) {
    return TEAMS_UPGRADE_TARGETS[normalizedCurrentTier] || normalizedRequestedTier
  }

  return normalizedRequestedTier
}
